var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUniversal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 15,
    fill: "url(#paint0_linear_9_158)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9998 26.1291H33.4099C33.2517 22.6867 32.1438 19.3632 30.2841 16.5144C34.4783 17.8201 37.6043 21.579 37.9995 26.1291H37.9998ZM27.0393 38.0785H26.9998H26.9602C26.7624 38.0785 26.5645 38.0785 26.3667 38.0389C24.0322 35.1505 22.6473 31.6289 22.4495 27.9494H31.5894C31.3915 31.6292 30.0067 35.1507 27.6722 38.0389C27.4348 38.0389 27.237 38.0785 27.0391 38.0785H27.0393ZM22.4495 26.1291C22.6473 22.4493 24.0322 18.9278 26.3667 16.0396C26.5645 16.0396 26.8019 16 26.9998 16C27.1976 16 27.435 16 27.6329 16.0396C29.9673 18.928 31.3522 22.4495 31.55 26.1291H22.4495ZM23.7157 16.5144C21.856 19.3632 20.7481 22.6869 20.5898 26.1291H16C16.3957 21.579 19.4819 17.8199 23.7154 16.5144H23.7157ZM16.0002 27.9496H20.5901C20.7483 31.392 21.8562 34.7154 23.7159 37.5643C19.5217 36.2586 16.3957 32.4997 16.0005 27.9496H16.0002ZM30.2843 37.5643C32.144 34.7154 33.2519 31.3918 33.4102 27.9496H38C37.6043 32.4997 34.5181 36.2588 30.2846 37.5643H30.2843Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_158",
    x1: 45,
    y1: 60,
    x2: 7,
    y2: -11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECC767"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversal);
export default __webpack_public_path__ + "static/media/universal.9241c59b3df8c451bbd447eba9e88a05.svg";
export { ForwardRef as ReactComponent };